import type { ETabBarSegments, IRouteItem, TSegmentedHistory } from '~/modules/tabBar/configs/tabBarConfig';

export const popLastPathFromActiveSegment = (
  segmentedHistory: TSegmentedHistory,
  activeSegment: ETabBarSegments,
): IRouteItem | undefined => {
  return segmentedHistory[activeSegment]?.values?.pop();
};

export const getPreLastPathFromActiveSegmentAndDeleteLast = (
  segmentedHistory: TSegmentedHistory,
  activeSegment: ETabBarSegments,
): IRouteItem | undefined => {
  const segment = segmentedHistory[activeSegment];

  if (!segment || !segment.values || segment.values.length < 2) {
    return undefined;
  }

  segment.values.pop();

  return segment.values[segment.values.length - 1];
};

export const getLastStepFromActiveSegment = (
  segmentedHistory: TSegmentedHistory,
  activeSegment: ETabBarSegments,
): IRouteItem | undefined => {
  const activeSegmentHistory = segmentedHistory[activeSegment]?.values;
  return activeSegmentHistory?.at(-1);
};

export const clearAllHistoryInSegmented = (
  segmentedHistory: TSegmentedHistory,
  segment: ETabBarSegments,
): void => {
  const activeSegmentHistory = segmentedHistory[segment];

  if (activeSegmentHistory) {
    activeSegmentHistory.values = [];
  }
};

export const addStepToHistory = (
  segmentedHistory: TSegmentedHistory,
  activeSegment: ETabBarSegments,
  step: IRouteItem,
): void => {
  const activeSegmentHistory = segmentedHistory[activeSegment]?.values;

  if (activeSegmentHistory) {
    activeSegmentHistory.push(step);
  }
};
